import { render, staticRenderFns } from "./dlView.vue?vue&type=template&id=70291030&scoped=true&"
import script from "./dlView.vue?vue&type=script&lang=js&"
export * from "./dlView.vue?vue&type=script&lang=js&"
import style0 from "./dlView.vue?vue&type=style&index=0&id=70291030&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70291030",
  null
  
)

export default component.exports